import React, { useState } from 'react'
import { RouteComponentProps } from 'react-router'

import Loading from 'components/Loading'
import PageHeader from 'App/components/PageHeader'
import { useGroup } from 'group/hooks/useGroup'
import { useEditGroup } from 'group/hooks/useEditGroup'
import GroupDetailTabs from 'group/components/GroupDetailTabs'

export const GroupsDetailNew = (props: RouteComponentProps<{ id: string }>) => {
  const groupId = props.match.params.id
  const [group, setGroup] = useState<any>(null)
  const { loading } = useGroup(groupId, setGroup)
  const [editGroup, { loading: editingGroup }] = useEditGroup(groupId, setGroup)

  if (loading || !group || editingGroup) {
    return <Loading />
  }

  return (
    <PageHeader title={group.name} subTitle="Back to All Groups" backLink="/groups">
      <GroupDetailTabs group={group} onGroupUpdate={editGroup} {...props} />
    </PageHeader>
  )
}

export default GroupsDetailNew
